export interface StepModelsState {
  // 當前步驟
  step: number;
  // 最大步驟
  maxStep: number;
  // 申請編號
  workNo: string;
  // 身份識別安全級別
  authLevel: number;
}

export const initStepModelsState = {
  step: 1,
  maxStep: 1,
  workNo: '',
  authLevel: 2,
};

export default {
  namespace: 'stepModels',
  state: initStepModelsState,

  reducers: {
    update: (state: StepModelsState, { payload }: { payload: Partial<StepModelsState> }) => ({
      ...state,
      ...payload,
    }),
    init: () => initStepModelsState,
  },
};
